import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import {
  getCoordinates,
  getVariants,
} from "../../../../redux/actions/apiActions";
import ServiceListItem from "./ServiceListItem";
import ChooseCarMobile from "components/common/ChooseCarMobile";

let header = {
  Accept: "application/json",
  "Content-Type": "application/json",
};
const ServiceList = ({
  setTypeOne,
  setServiceData,
  serviceData,
  show,
  setShow,
  handleShow,
  variants: data,
  globalData,
  getCarBrandModal,
  apiData,
  getModel,
  getWorkshopFilterMap,
  variantId,
  cart,
  id,
  getVariants,
}) => {
  const [showDescription, setShowDescription] = useState(null);
  const [locationMap, setLocationMap] = useState(false);
  const [variants, setVariants] = useState(false);
  const [showMobileChooseCar, setShowMobileChooseCar] = useState(false);

  useEffect(() => {
    if (data && data.length && data[0].JourneyCategoryId == id) {
      setVariants(data);
    } else {
      getVariants(id, globalData?.carData?.modelId, cart.workshop?.Id);
      setVariants([]);
    }
  }, [data]);

  return variants != "" && variants != null && variants != undefined ? (
    <>
      {/* {globalData.carData?.brand && <ProductVariantTourFlow />} */}

      {/* <div className="your-mobile-location mt-2">
        <p>
          Your Car Location:{" "}
          <span className="text-black">
            {globalData.locationData?.data?.EmirateArea}
          </span>{" "}
          <span className="badge" onClick={() => setLocationMap(true)}>
            Change
          </span>
        </p>
      </div> */}

      {/* <MobileLocation
        show={locationMap}
        handleClose={() => setLocationMap(false)}
      /> */}

      <ChooseCarMobile
        show={showMobileChooseCar}
        setShow={setShowMobileChooseCar}
      />

      {variants.map((variant, index) => {
        if (variant.Id == variantId) {
          return (
            <Row key={index}>
              <ServiceListItem
                setTypeOne={setTypeOne}
                show={show}
                showDescription={showDescription}
                setShowDescription={setShowDescription}
                handleShow={handleShow}
                variant={variant}
                getModel={getModel}
                getCarBrandModal={getCarBrandModal}
                index={index}
                id={id}
                isSlug={true}
                showMobileChooseCar={showMobileChooseCar}
                setShowMobileChooseCar={setShowMobileChooseCar}
              />
            </Row>
          );
        } else {
          return <></>;
        }
      })}

      {variants.map((variant, index) => {
        if (variant.Id != variantId) {
          if (
            cart.workshop &&
            variant.IslandType != "WORKSHOPPURCHASE" &&
            cart.workshop?.Id != apiData.defaultWorkshop?.Id
          ) {
            return;
          }
          return (
            <Row key={index}>
              <ServiceListItem
                setTypeOne={setTypeOne}
                show={show}
                handleShow={handleShow}
                showDescription={showDescription}
                setShowDescription={setShowDescription}
                getWorkshopFilterMap={getWorkshopFilterMap}
                variant={variant}
                getModel={getModel}
                getCarBrandModal={getCarBrandModal}
                index={index}
                id={id}
                isSlug={false}
                showMobileChooseCar={showMobileChooseCar}
                setShowMobileChooseCar={setShowMobileChooseCar}
              />
            </Row>
          );
        } else {
          return <></>;
        }
      })}
    </>
  ) : (
    <div></div>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    globalData: state.globalData,
    apiData: state.apiData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVariants: (id, mId, WId) => {
      dispatch(getVariants(id, mId, WId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceList);
